import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CurrentPortfolio } from 'src/app/models/current-portfolio.model';
import { CurrentStrategyTarget } from "../../models/current-strategy-target.model";
import { Cluster } from 'src/app/models/cluster.model';
import { ClustersService } from 'src/app/services/clusters.service';
import { InvestableParameters } from 'src/app/models/investable-parameters.model';
import { InvestableService } from 'src/app/services/investable.service';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-investable-solution',
  templateUrl: './investable-solution.component.html',
  styleUrls: ['./investable-solution.component.scss']
})

export class InvestableSolutionComponent implements OnInit, OnDestroy {

  currentCluster: Cluster;
  currentClusterSubscription: Subscription;

  currentOriginal: CurrentPortfolio;
  currentOriginalSubscription: Subscription;
  currentStrategy: CurrentStrategyTarget;
  currentStrategySubscription: Subscription;

  isComputing: boolean = false;

  investableParameters: InvestableParameters;
  investableParametersSubscription: Subscription;

  selectBlock: string = '';
  selectedPage2: string = 'weights';

  optimizeOk: boolean = false;
  improveOk: boolean = false;

  panelOpenState = false;

  constructor(private clustersService: ClustersService,
              private investableService: InvestableService,
              private notificationsService: NotificationsService) {
    // TODO: Add possibility to make a specific notification last forever
    this.notificationsService.notify('completeness/too_few_ingredients');
  }

  ngOnInit(): void {
    this.subscribeToInvestableParameters();
    this.subscribeToCurrentCluster();
    this.subscribeToCurrentOriginal();
    this.subscribeToCurrentStrategy();
  }

  ngOnDestroy() {
    if (this.currentClusterSubscription != undefined) { this.currentClusterSubscription.unsubscribe(); }
    if (this.currentOriginalSubscription != undefined) { this.currentOriginalSubscription.unsubscribe(); }
    if (this.currentStrategySubscription != undefined) { this.currentStrategySubscription.unsubscribe(); }
    if (this.investableParametersSubscription != undefined) { this.investableParametersSubscription.unsubscribe(); }
    this.investableService.resetInvestableParameters();
  }

  subscribeToCurrentCluster() {
    this.currentClusterSubscription = this.clustersService.currentClusterSubject.subscribe(
      (cluster: Cluster) => {
        if (cluster!=undefined) {
          this.currentCluster = cluster;
        }
      }
    );
    this.clustersService.emitCurrentCluster();
  }

  subscribeToInvestableParameters() {
    this.investableParametersSubscription = this.investableService.investableParametersSubject.subscribe(
      (investableParameters: InvestableParameters) => {
        this.investableParameters = investableParameters;
      }
    );
    this.investableService.emitInvestableParameters();
  }

  subscribeToCurrentOriginal() {
    this.currentOriginalSubscription = this.clustersService.currentOriginalSubject.subscribe(
      (original_portfolio: CurrentPortfolio) => {
        if (original_portfolio != this.currentOriginal) {
          this.investableParameters.setComponents(
            original_portfolio.componentsAnalysis.components.map((component) => {
              return {
                name: component.name,
                weight: component.weight,
                min_weight: 0.,
                max_weight: 1.,
                alpha: component.alpha
              }
            })
          );
        }
        this.currentOriginal = original_portfolio;
      }
    );
    this.clustersService.emitCurrentOriginal();
  }

  subscribeToCurrentStrategy() {
    this.currentStrategySubscription = this.clustersService.currentStrategySubject.subscribe(
      (strategy: CurrentStrategyTarget) => {
        this.currentStrategy = strategy;
      }
    );
    this.clustersService.emitCurrentStrategy();
  }

  onChangeBlock(selectBlock: string) {
    this.selectBlock = selectBlock;
  }

}
